export default import.meta.ROLLDOWN_FILE_URL_CoH3UVI0hmDAlfmt7NhXQA